module.exports = __webpack_public_path__ + "files/92a61c44666d7ce1b637cf4d7069ad54.png";